export function assert(cond: boolean): asserts cond {
  if (!cond) {
    throw new Error('Condition is false');
  }
}
